import { ColumnFactory } from '../excel';
export const TransportationColumns = new ColumnFactory()
  .addColumnsFromPredefined('content')
  .addColumnsFromPredefined('status')
  .addColumnsFromPredefined('driver')
  .addColumnsFromPredefined('vehicle')
  .addColumnsFromPredefined('startPoint')
  .addColumnsFromPredefined('endPoint')
  .addColumnsFromPredefined('totalDuration')
  .addColumnsFromPredefined('totalDistance')
  .addColumnsFromPredefined('beginDate')
  .addColumnsFromPredefined('endDate')
  .getColumns();
